
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { setCreatePostStore, setField, useCreatePostStore } from '..'
import styles from '../../../common/styles'
import { DPButton } from '../../../common/types'

interface Props extends DPButton {}

const CloudinaryUploadButton = (props: Props) => {

	const isVideoUploaded = useCreatePostStore((s) => s.isVideoUploaded)

	const cloudinaryRef = useRef<any>()

	useEffect(() => {
		cloudinaryRef.current = (window as any).cloudinary.createUploadWidget(
      {
        cloudName: "ds3ctqoro",
        uploadPreset: "sv8o83ub",
        sources: ["local"],
        multiple: false,
        clientAllowedFormats: ["video"],
        maxVideoFileSize: "40000000",
        showUploadMoreButton: false
      },
      (err, res) => {
        if (res.event == "queues-end") {
          const { secure_url, thumbnail_url } = res.info.files[0].uploadInfo;
          setField("videoId", secure_url);
          setCreatePostStore({ thumbnail_url });
          setCreatePostStore({ isVideoUploaded: true });
        }
      }
    );
	}, [])

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		cloudinaryRef.current.open()
	}

	return (
    <Button isUploaded={isVideoUploaded} disabled={props.disabled || isVideoUploaded} onClick={handleClick}>
      {isVideoUploaded ? "Uploaded" : "Upload"}
    </Button>
  );
}

const Button = styled.button(({isUploaded}: {isUploaded: boolean}) => [
	tw`text-[0.5rem] h-8 `,
	isUploaded && tw`font-bold`,
	styles.border
])

export default CloudinaryUploadButton